import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { API_URL } from '../config/api';
import ActiveOrder from './ActiveOrder';
import './ActiveOrderFloatingPopup.css';

const ActiveOrderFloatingPopup = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [activeOrder, setActiveOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!user) {
      setActiveOrder(null);
      setLoading(false);
      return;
    }
    const fetchActiveOrder = async () => {
      try {
        const response = await axios.get(`${API_URL}/orders/active`);
        setActiveOrder(response.data);
      } catch (error) {
        if (error.response?.status === 404) {
          setActiveOrder(null);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchActiveOrder();
    const interval = setInterval(fetchActiveOrder, 5000);
    return () => clearInterval(interval);
  }, [user]);

  const shouldShow = Boolean(user && activeOrder && !location.pathname.startsWith('/admin'));

  if (loading || !shouldShow) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="active-order-floating-popup"
        onClick={() => setShowModal(true)}
        aria-label="View active order"
      >
        <i className="fas fa-truck"></i>
      </button>

      {showModal && (
        <div
          className="active-order-modal-overlay"
          onClick={() => setShowModal(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Active order"
        >
          <div
            className="active-order-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="active-order-modal-close"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            >
              <i className="fas fa-times"></i>
            </button>
            <div className="active-order-modal-body">
              <ActiveOrder />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActiveOrderFloatingPopup;
